var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"import-sheet",on:{"click":function($event){return _vm.importFile()}}},[_c('aha-icon',{staticClass:"mr-1",attrs:{"name":"document-excel"}}),_c('span',[_vm._v(_vm._s(_vm.$i18nPresenter.t('Import Excel')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }